export const environment = {
  production: true,
  firebase: {},
  encryptionKey:'RdAO2InTo6jl4ArLYyIInQ==',
  debug: false,
  log: {
    auth: false,
    store: false,
  },
  smartadmin: {
    api: null,
    db: 'smartadmin-angular'
  },
  readmore_URL:"https://www.io-market.com/loesungen/edi-netzwerk/",
  COOKIE_ENABLED_DOMAINS:['api-business.io-market.net','dhdgu.api.io-market.net','fjy29.api.io-market.net','fkbwl.api.io-market.net','fkbwl.api.epost.gate2b.net'],
  checkCookie:"expireCookie",
  tokenExpireTime:"cookieCreatedTime",
  ticket_URL :"http://api.ticket.g2bngt.io-procurement.com/ws/createTicketFromGate2B.cfc?wsdl&method=createTicketFromGate2B",
  privateKey:{key:"MIIEpAIBAAKCAQEAx5DMt1FGNFvMerMldZeh7o8iPdSrknRV6kCJfTfA60lMsJtFRbgwmED6jdpXoYG+Zh+Lt9nsCm8Mkj2c8ZFa3Gx3ANVZAJqcz7ztR/HFxVw2VIDEbbpQuVfbbf9O1W4WzOgvuWidPNNXuY62WRNnE/H4MkYVE8Bh+dN/c3VQhGycbvmuYjV6cG/EQv21vrJkCn0dMAx/wzo9ZQyxcsU0jUEOJczbnQyr4UoYsWtNQIXpZTQStRR3pbvNeyP2Ab7zo1ridahE+UkETQclaif80fGZ/3DcMpCR1SD0mryUb8z3pAwrygzuORRjs0augbvhAZg2WjVvfWbVepgF3KBlbwIDAQABAoIBAHab6gAeLvKZiMt4RBBC4fxuV7SV/K8bs6B5YP3qMB/nPcxNTHumgENNg1zh42lbOnVp1FmeDLsay0bzlZ7BfFY7pPL62l4Qhpi1OfWjjZ7CMoxAx/5LWQT/YaxbrFgPiT+Z1BuHQMTQ+3eOiXQhowborlH68zX9Bn48JKjTldpNwg2YZvPeZidWGKhqkeQIgj/wsM0fGUl5aR+xqTRt5ZOydjITDXKFQh6Ms+lhW+w73AaKfVZ16VVWrBCXqIjnVM6HUuzSv2SeJmlHZetw9uvvHBDZf0kYzC3DLpTtyqLacoplKc3kxQiV/vJuiwubVgLqHDeEawqEH7jWjKJa1dECgYEA7ptjGuYk1l0H/fWQn0BlPRVZO/l37bbkzyYJZbRh2SAxYgeh+EluXviRXDKwcRSkCnyNSM6cDf33f5U9pw46mCCXZPvfoFaIRJ70SF/2CMtiXyiw+o1ykEBKr12LNiK829+NrAQph9CGaAhm5AmGDsjDN20192Kje2HJ4z5YX7cCgYEA1hzd9HVA9EYCylPzc4BeeZ191ltd053p2a8PVJ2k2cToOcnBz+81MOfPKiyNzfVEdgSS95yCjHRP0CkViVsp/UpVHhVhRYgDU5nskKMfHvu1VG6RPjnWBhzWIwJrm+E6yxl0/NMuLkqQk14tl2NhQqq3kgs/D0TuJks2o6QTOAkCgYBCJWF7+4EKzA+DH6hP/ZITNO/f6HCOvb0AkBLa1v6pKnuGKYeFRRYLzey+Gm8/afFv1sdz/5LTbixGeiD1RsSHl8FghVKhKFvuagJebfvOxFMo/ibRzpSL2MbbhpspDsg8S+UCYsUAmZYpEOs1HE7FmnJD00q6oeWgNqO5E3d8UQKBgQCNx72986rYVkfgvKiYEif9NimuuP+vcoD4sbBgIqeXwIjaQ1yAmXDKeqW20pvwBvqXf73mExBre1WijKIDO4fZftBQRG4OAdvaDzIUMMAZ3ymayECLSPcNQykVM7QYG5O4C5ppFFofMyb7PsDH33n3EF7QaXwPW2CroOCEidBkKQKBgQDnF4bqesdBbtlET7ZnxDtaCJw/kZg1SFdeJWDUCNDOKmMu5zCdoisDFjvt5qLIIPPDPiwxf0hQXGJl76afE9rz03IYC98DtjrKxNmJzH8832PcZgDE4Z//8Bjn4ht+WZN7zcMcpXftrMKVtMLkQCSeBOMaBz4qUj3FcgqOVSKMSA=="},
  languageCookie:'languageCookie',
  styleCookie:'styleCookie',
  FORMATS:{'OpenTrans_Special2.1':'.xml','UBL3.0.1':'.XML','UBL3.1':'.XML','ZUGFERD1.0':'.PDF','UBL2.1':'.XML','ABADOC2.0034':'.pdf','EDIFACTD.96A':'.edi','CXMLWithPDF':'.xml', "CXML1.2":'.xml', 'ETS3.1':'.xml', 'SAP02' :'.xml', 'OpenTrans2.1':'.xml','EDIFACTD.01B':'.edi','YellowBill2.0':'.xml','SignedYellowBill2.0':'.xml','Comarch1.0':'.xml','ETS2.0':'.xml','SAP05':'.xml','QR PDF':'.pdf','Meta Coded PDF':'.pdf' },
  WC_APPS:"https://wc.io-market.net/subscribedApps/main.js",
  WC_PROFILE:"https://wc.io-market.net/profile/main.js",
  USER_ACTIVE_CHECK:"isUserActive",
  BEXIO_URL:"https://bexio.io-market.net/",
  SUPPORT_URL:'https://support.io-market.net/#/edi/',
  userInfo:"userInfo",
  APPLICATION_VERSION:"8",
  posfinance_id:"41100000007797776",
  interconnect_posfinance_receive_iomID:"41100000000023711",
  MTC_URL: "https://mtc.io-market.net/#/",
  mtc_cookie: "mtc_cookie",
  EBILL_MAIL:"ebillgateway@io-market.com",
  permissions: 'permissions',
  EBILL_QR_INVOICE: "D_EBILL_QR_PDF_SPEZIFIKATION_DE_2022.PDF",
  color:"colorChangeTest",
  EBILL_ERROR_PRICE:"0.20",
  cookieConsent: 'cookieConsent',
  tax:"0.081",
  COMPARE_API: "https://dwncu.api.io-market.net/api/v1/main/",
  parentNetcomId:"parentNetcomId",
  ARCHIVE_END_POINT:"https://rwe95.api.io-netgate.net/api/v1/",
  TENANT_MAPPING: {
            "41420-0000425694-68": "MIGROL",
            "41420-0000425696-62": "MIGROL_MARKETING",
            "41420-0000426262-13": "Migrol_INTERNAL",
            "41420-0000426263-6": "MIGROL_MARKETING INTERNAL"
        },
  NOTIFICATION_END_POINT:"https://gtswg.api.io-market.net"
};